module.exports = __webpack_public_path__ + "media/images/icons/play-567ed5e3bad5f646ddb946cf3c159a2d.svg";